import React from "react";
import {Button, Popover} from "@mui/material";
import {ArrowDropDown} from "@mui/icons-material";
import '~/components/visualization/api-dropdown-filter/ApiDropdownFilterComponent.scss';

type Props = {
    label: string
    /** e.g. "Any" or the selected value */
    status: string
    active: boolean
    disabled?: boolean
    onOpen?: () => void
    children: (close: () => void) => React.ReactNode
}

/**
 * A "Label: Any" filter button that opens a popover, styled like the other filter bar buttons.
 */
export const FilterChipPopover: React.FC<Props> = ({label, status, active, disabled, onOpen, children}) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const close = () => setAnchorEl(null);
    return <>
        <Button
            className={'api-dropdown-filter-component-button api-dropdown-filter-chip' + (active ? ' active' : '')}
            variant="outlined"
            disableElevation
            disabled={disabled}
            endIcon={<ArrowDropDown/>}
            onClick={e => {
                setAnchorEl(e.currentTarget);
                onOpen?.();
            }}>
            <span className="api-dropdown-filter-chip-label">{label}:</span>&nbsp;<b>{status}</b>
        </Button>
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={close}
            anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
            transformOrigin={{vertical: 'top', horizontal: 'left'}}>
            {anchorEl && children(close)}
        </Popover>
    </>;
}
